var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-container"},[_c('video',{staticClass:"vjs-big-play-centered video-js vjs-default-skin vjs-fill",attrs:{"id":_vm.id,"controls":"","preload":"none","height":"100%","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }